import React, { FC } from 'react';

interface IProps {
  className?: string;
}

const IconLogoDarkThemeSmall: FC<IProps> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="-0.5 0 31 39.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
    <g>
        <path d="M30.4689 8.6456L28.4943 16.015L26.3572 24.01L24.3826 31.3794L22.4705 38.5111C20.6583 39.0741 18.7462 39.3744 16.7466 39.3744C15.8218 39.3744 14.9094 39.3119 14.0221 39.1867L16.1092 31.3794L18.0838 24.01L20.2209 16.015L21.0833 12.787C22.183 8.68314 15.9092 8.6456 15.9092 8.6456H13.8971L11.9225 16.015L9.78542 24.01L7.8108 31.3794L6.46106 36.4216C3.79907 34.7451 1.562 32.4304 -0.0126953 29.7028L1.51201 24.01L3.6491 16.015L5.62372 8.6456L7.07344 3.24053C9.92289 1.6015 13.2348 0.650604 16.7591 0.650604C19.3086 0.650604 21.7456 1.13856 23.9702 2.03941L22.1955 8.6456H30.4689Z" fill="#189CD8"/>
    </g>
  </svg>
  );
};

export default IconLogoDarkThemeSmall;
